import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminCompany from './AdminCompany';

export default withRequiredAdmin(AdminCompany);
